import React, { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Send, MessageSquare } from "lucide-react";

export default function InJobChat({ bookingId, otherName }) {
  const { user } = useAuth();
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const scrollRef = useRef(null);

  const load = async () => {
    try {
      const { data } = await api.get(`/bookings/${bookingId}/messages`);
      setMsgs(data);
    } catch {}
  };

  useEffect(() => {
    if (!bookingId) return;
    load();
    const id = setInterval(load, 4000);
    return () => clearInterval(id);
    // eslint-disable-next-line
  }, [bookingId]);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [msgs]);

  const send = async () => {
    if (!text.trim()) return;
    try {
      const { data } = await api.post(`/bookings/${bookingId}/messages`, { message: text });
      setMsgs((m) => [...m, data]);
      setText("");
    } catch {}
  };

  return (
    <div className="bg-white border-2 border-asap-deep" data-testid="in-job-chat">
      <div className="px-4 py-3 bg-asap-deep text-white flex items-center gap-2">
        <MessageSquare size={18} className="text-asap-yellow"/>
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-[0.3em] text-asap-yellow font-bold">In-Job Chat</div>
          <div className="font-bold">{otherName || "Counterparty"}</div>
        </div>
      </div>
      <div ref={scrollRef} className="max-h-64 overflow-y-auto p-3 space-y-2 bg-slate-50" data-testid="chat-messages">
        {msgs.length === 0 && <div className="text-xs text-slate-400 text-center py-6">No messages yet. Say hi!</div>}
        {msgs.map((m) => {
          const mine = m.author_id === user.id;
          return (
            <div key={m.id} className={`max-w-[80%] ${mine ? "ml-auto" : ""}`}>
              <div className={`px-3 py-2 rounded text-sm ${mine ? "bg-asap-deep text-white" : "bg-asap-yellow text-asap-deep"}`}>
                {m.message}
              </div>
              <div className={`text-[10px] mt-0.5 ${mine ? "text-right" : ""} text-slate-400`}>{new Date(m.created_at).toLocaleTimeString()}</div>
            </div>
          );
        })}
      </div>
      <div className="p-2 border-t-2 border-asap-deep flex gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Message…" className="flex-1 px-3 py-2 border-2 border-asap-deep outline-none text-sm" data-testid="chat-input"/>
        <button onClick={send} data-testid="chat-send" className="px-3 py-2 bg-asap-yellow text-asap-deep border-2 border-asap-deep"><Send size={14}/></button>
      </div>
    </div>
  );
}
